import { isEmpty } from "lodash";

const TemplateBox = ({ selectedDataElement, jsonPath, csvPath, version }) => {
	const documentName = selectedDataElement?.name || "Data Element Name";

	if (isEmpty(selectedDataElement)) {
		return null;
	}

	const versionSuffix = version ? `_v${version}` : "";

	return (
		<div className="template-box__sharedData">
			<div className="template-box__header">
				<div className="template-box__header__right">
					<div className="template-box__header__title">
						Download Templates
					</div>
				</div>
			</div>
			<div className="template-box__content">
				Here are the templates you can use as reference for <b>{documentName}</b>{version ? <> (version <b>v{version}</b>)</> : null}<br />
				Please click and download <a href={jsonPath} download={`json_template_${selectedDataElement.id}${versionSuffix}.json`}>JSON Template</a> or <a href={csvPath} download={`csv_template_${selectedDataElement.id}${versionSuffix}.csv`}>CSV Template</a>.
			</div>
		</div>
	);
};

export default TemplateBox;
